function getLineLengthWeightMod() {
  return (lines) => lines.map((line) => line.distanceSq());
}
export {
  getLineLengthWeightMod
};
//# sourceMappingURL=index191.js.map
